// Auto-loads any image dropped into src/assets/images/services/ named
// after its section number (01.jpg, 02.png, 03.webp, ...) and maps it
// to that section's `n` value, so servicesSections.js entries pick up
// their image automatically without further code changes.
const req = require.context('../assets/images/services', false, /^\.\/(\d{2})\.(png|jpe?g|webp)$/i);

const images = {};
req.keys().forEach((key) => {
  const match = key.match(/^\.\/(\d{2})\./);
  if (match) images[match[1]] = req(key);
});

export default images;
